import Immutable from 'immutable'
import {
  LOGIN_REQUEST,
  LOGIN_SUCCESS,
  LOGIN_ERROR,
  LOGOUT_REQUEST,
  LOGOUT_SUCCESS,
  LOGOUT_ERROR,
  REGISTER_REQUEST,
  REGISTER_SUCCESS,
  REGISTER_ERROR,
  SET_NEXT_URL,
  SET_CURRENT_USER,
  CLEAR_LOGIN_ERROR,
  SAVE_ACCOUNT_REQUEST,
  SAVE_ACCOUNT_SUCCESS,
  SAVE_ACCOUNT_ERROR,
  FORGOT_PASSWORD_REQUEST,
  FORGOT_PASSWORD_SUCCESS,
  FORGOT_PASSWORD_ERROR,
  RESET_PASSWORD_REQUEST,
  RESET_PASSWORD_SUCCESS,
  RESET_PASSWORD_ERROR,
  CLEAR_PASSWORD_RESET_STATE
} from '../actions/login'
import { parseErrorResponse } from '../utils/errors'

export default (
  state = Immutable.Map({
    currentUser: null,
    isAdminUser: false,
    nextUrl: '/',
    inProgress: false,
    error: null,
    registered: false,
    forgotPasswordSent: false,
    passwordResetSuccess: false
  }),
  action
) => {
  const initialState = Immutable.Map({
    currentUser: null,
    isAdminUser: false,
    nextUrl: '/',
    inProgress: false,
    error: null,
    registered: false,
    forgotPasswordSent: false,
    passwordResetSuccess: false
  })
  switch (action.type) {
    case LOGIN_REQUEST:
    case LOGOUT_REQUEST:
    case REGISTER_REQUEST:
      return state
        .set('currentUser', null)
        .set('inProgress', true)
        .set('error', null)
    case SAVE_ACCOUNT_REQUEST:
      return state.set('inProgress', true).set('error', null)
    case LOGIN_SUCCESS:
      return state
        .set('currentUser', action.currentUser)
        .set(
          'isAdminUser',
          action.currentUser &&
            action.currentUser.get('retailerType') === 'admin'
        )
        .set('inProgress', false)
    case REGISTER_SUCCESS:
      return state.set('inProgress', false).set('registered', true)
    case SAVE_ACCOUNT_SUCCESS:
      return state.set('inProgress', false)
    case LOGIN_ERROR:
    case LOGOUT_ERROR:
    case REGISTER_ERROR:
    case SAVE_ACCOUNT_ERROR:
      return state
        .set('inProgress', false)
        .set('error', parseErrorResponse(action.error))
    case LOGOUT_SUCCESS:
      return initialState
    case SET_NEXT_URL:
      return state.set('nextUrl', action.url)
    case SET_CURRENT_USER:
      return state
        .set('currentUser', action.currentUser)
        .set(
          'isAdminUser',
          action.currentUser &&
            (typeof action.currentUser.get === 'function'
              ? action.currentUser.get('retailerType') === 'admin'
              : action.currentUser.retailerType === 'admin')
        )
    case CLEAR_LOGIN_ERROR:
      return state.set('error', null)
    case FORGOT_PASSWORD_REQUEST:
    case RESET_PASSWORD_REQUEST:
      return state.set('inProgress', true).set('error', null)
    case FORGOT_PASSWORD_SUCCESS:
      return state.set('inProgress', false).set('forgotPasswordSent', true).set('error', null)
    case RESET_PASSWORD_SUCCESS:
      return state.set('inProgress', false).set('passwordResetSuccess', true).set('error', null)
    case FORGOT_PASSWORD_ERROR:
    case RESET_PASSWORD_ERROR:
      return state.set('inProgress', false).set('error', parseErrorResponse(action.error))
    case CLEAR_PASSWORD_RESET_STATE:
      return state
        .set('forgotPasswordSent', false)
        .set('passwordResetSuccess', false)
        .set('error', null)
        .set('inProgress', false)
    default:
      return state
  }
}
